module.exports = __webpack_public_path__ + "static/media/pets-with-animo.30cf2a84.png";